import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import uiState from './uiStateReducer';
import userAccount from './userAccountReducer';
import emailEnterpriseMap from './emailEnterpriseMapReducer';
import enterprises from './enterprisesReducer';

export default combineReducers({
    router: routerReducer,
    uiState,
    userAccount,
    emailEnterpriseMap,
    enterprises
});


// WEBPACK FOOTER //
// ./src/reducers/index.js